module.exports = __webpack_public_path__ + "img/logout.e585e310.svg";